const PATH = 'app/Auth';

export const SAVE_LOGIN_USER_STATUS = `${PATH}SAVE_LOGIN_USER_STATUS`;
export const SAVE_USER_EXPIRE_SUCCESS = `${PATH}SAVE_USER_EXPIRE_SUCCESS`;
export const SEND_ACTIVE_USER_REQUEST = `${PATH}SEND_ACTIVE_USER_REQUEST`;
export const SEND_ACTIVE_USER_SUCCESS = `${PATH}SEND_ACTIVE_USER_SUCCESS`;
export const SAVE_EXPIRE_STATUS_REQUEST = `${PATH}SAVE_EXPIRE_STATUS_REQUEST`;